import moment from 'moment';
import { DATE_FORMAT, REQUEST_DATE_FORMAT } from '../../constants';
export const setAppliedFilter = (selectedFilters, dateFilter) => {
    let tempSelectedFilters = []
    selectedFilters.forEach(item => {
        tempSelectedFilters.push(item);
    })
    if (dateFilter.toDate && dateFilter.fromDate) {
        /* tempSelectedFilters.push({ label: moment(dateFilter.fromDate).format(DATE_FORMAT), value: 'fromDate' })
        tempSelectedFilters.push({ label: moment(dateFilter.toDate).format(DATE_FORMAT), value: 'toDate' }) */
        tempSelectedFilters.push({ label: (moment(dateFilter.fromDate).format(DATE_FORMAT) + ' to ' + moment(dateFilter.toDate).format(DATE_FORMAT)), value: 'date' })
    }
    return tempSelectedFilters;
}

export const deleteAppliedFilters = (removeFilter, appliedFilters) => {
    let tempAppliedFilters = [...appliedFilters];
    tempAppliedFilters.forEach((item, index, element) => {
        if (item.value === removeFilter.value) {
            appliedFilters.splice(index, 1)
        }
    })
    return appliedFilters;
}

export const deleteEntityFilter = (selectedEntity, removeFilter) => {
    let tempSelectedData = copyArray(selectedEntity);
    for (let i = 0; i < tempSelectedData.length; i++) {
        if (tempSelectedData[i].value === removeFilter.value) {
            tempSelectedData.splice(i, 1);
            break;
        }
    }
    return tempSelectedData;
}

export const copyArray = (data) => {
    let tempLevelOne = JSON.stringify(data);
    return JSON.parse(tempLevelOne)
}

export const getRequestBody = (selectedEntity, toDate, fromDate) => {
    let tempRequestBody = {
        correspondentEntityIds: getEntityIds(selectedEntity),
        toDate: moment(toDate),
        fromDate: moment(fromDate)
    }
    return tempRequestBody
}

export const getRequestBodyList = (requestDefaultBody, selectedEntity, toDate, fromDate) => {
    let tempRequestBody = {
        ...requestDefaultBody,
        request: {
            correspondentEntityIds: getEntityIds(selectedEntity),
            toDate: toDate ? moment(toDate).format(REQUEST_DATE_FORMAT) : toDate,
            fromDate: fromDate ? moment(fromDate).format(REQUEST_DATE_FORMAT) : fromDate
        }
    }
    return tempRequestBody
}
const getEntityIds = (selectedEntityData) => {
    let tempSelectedEntityId = []
    selectedEntityData.forEach(item => {
        tempSelectedEntityId.push(item.value)
    })
    return tempSelectedEntityId
}